import {
  IUnsubscribeGroup,
  CreateUnsubscribeGroupRequest,
  UpdateUnsubscribeGroupRequest,
  GetUnsubscribeGroupsResponse,
} from '../../types/unsubscribeGroups/unsubscribeGroups.types';

// Action type constants
export const GET_UNSUBSCRIBE_GROUPS_REQUEST = 'GET_UNSUBSCRIBE_GROUPS_REQUEST';
export const GET_UNSUBSCRIBE_GROUPS_SUCCESS = 'GET_UNSUBSCRIBE_GROUPS_SUCCESS';
export const GET_UNSUBSCRIBE_GROUPS_FAILURE = 'GET_UNSUBSCRIBE_GROUPS_FAILURE';

export const GET_UNSUBSCRIBE_GROUP_REQUEST = 'GET_UNSUBSCRIBE_GROUP_REQUEST';
export const GET_UNSUBSCRIBE_GROUP_SUCCESS = 'GET_UNSUBSCRIBE_GROUP_SUCCESS';
export const GET_UNSUBSCRIBE_GROUP_FAILURE = 'GET_UNSUBSCRIBE_GROUP_FAILURE';

export const CREATE_UNSUBSCRIBE_GROUP_REQUEST =
  'CREATE_UNSUBSCRIBE_GROUP_REQUEST';
export const CREATE_UNSUBSCRIBE_GROUP_SUCCESS =
  'CREATE_UNSUBSCRIBE_GROUP_SUCCESS';
export const CREATE_UNSUBSCRIBE_GROUP_FAILURE =
  'CREATE_UNSUBSCRIBE_GROUP_FAILURE';

export const UPDATE_UNSUBSCRIBE_GROUP_REQUEST =
  'UPDATE_UNSUBSCRIBE_GROUP_REQUEST';
export const UPDATE_UNSUBSCRIBE_GROUP_SUCCESS =
  'UPDATE_UNSUBSCRIBE_GROUP_SUCCESS';
export const UPDATE_UNSUBSCRIBE_GROUP_FAILURE =
  'UPDATE_UNSUBSCRIBE_GROUP_FAILURE';

export const DELETE_UNSUBSCRIBE_GROUP_REQUEST =
  'DELETE_UNSUBSCRIBE_GROUP_REQUEST';
export const DELETE_UNSUBSCRIBE_GROUP_SUCCESS =
  'DELETE_UNSUBSCRIBE_GROUP_SUCCESS';
export const DELETE_UNSUBSCRIBE_GROUP_FAILURE =
  'DELETE_UNSUBSCRIBE_GROUP_FAILURE';

export const CLEAR_UNSUBSCRIBE_GROUP_STATE = 'CLEAR_UNSUBSCRIBE_GROUP_STATE';

// Action interfaces
export interface GetUnsubscribeGroupsRequestAction {
  type: typeof GET_UNSUBSCRIBE_GROUPS_REQUEST;
  [key: string]: any;
}

export interface GetUnsubscribeGroupsSuccessAction {
  type: typeof GET_UNSUBSCRIBE_GROUPS_SUCCESS;
  payload: GetUnsubscribeGroupsResponse;
  [key: string]: any;
}

export interface GetUnsubscribeGroupsFailureAction {
  type: typeof GET_UNSUBSCRIBE_GROUPS_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface GetUnsubscribeGroupRequestAction {
  type: typeof GET_UNSUBSCRIBE_GROUP_REQUEST;
  payload: string;
  [key: string]: any;
}

export interface GetUnsubscribeGroupSuccessAction {
  type: typeof GET_UNSUBSCRIBE_GROUP_SUCCESS;
  payload: IUnsubscribeGroup;
  [key: string]: any;
}

export interface GetUnsubscribeGroupFailureAction {
  type: typeof GET_UNSUBSCRIBE_GROUP_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface CreateUnsubscribeGroupRequestAction {
  type: typeof CREATE_UNSUBSCRIBE_GROUP_REQUEST;
  payload: CreateUnsubscribeGroupRequest;
  [key: string]: any;
}

export interface CreateUnsubscribeGroupSuccessAction {
  type: typeof CREATE_UNSUBSCRIBE_GROUP_SUCCESS;
  payload: IUnsubscribeGroup;
  [key: string]: any;
}

export interface CreateUnsubscribeGroupFailureAction {
  type: typeof CREATE_UNSUBSCRIBE_GROUP_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface UpdateUnsubscribeGroupRequestAction {
  type: typeof UPDATE_UNSUBSCRIBE_GROUP_REQUEST;
  payload: UpdateUnsubscribeGroupRequest;
  [key: string]: any;
}

export interface UpdateUnsubscribeGroupSuccessAction {
  type: typeof UPDATE_UNSUBSCRIBE_GROUP_SUCCESS;
  payload: IUnsubscribeGroup;
  [key: string]: any;
}

export interface UpdateUnsubscribeGroupFailureAction {
  type: typeof UPDATE_UNSUBSCRIBE_GROUP_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface DeleteUnsubscribeGroupRequestAction {
  type: typeof DELETE_UNSUBSCRIBE_GROUP_REQUEST;
  payload: string;
  [key: string]: any;
}

export interface DeleteUnsubscribeGroupSuccessAction {
  type: typeof DELETE_UNSUBSCRIBE_GROUP_SUCCESS;
  payload: string;
  [key: string]: any;
}

export interface DeleteUnsubscribeGroupFailureAction {
  type: typeof DELETE_UNSUBSCRIBE_GROUP_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearUnsubscribeGroupStateAction {
  type: typeof CLEAR_UNSUBSCRIBE_GROUP_STATE;
  [key: string]: any;
}

// Union type for all unsubscribe group actions
export type UnsubscribeGroupsActionTypes =
  | GetUnsubscribeGroupsRequestAction
  | GetUnsubscribeGroupsSuccessAction
  | GetUnsubscribeGroupsFailureAction
  | GetUnsubscribeGroupRequestAction
  | GetUnsubscribeGroupSuccessAction
  | GetUnsubscribeGroupFailureAction
  | CreateUnsubscribeGroupRequestAction
  | CreateUnsubscribeGroupSuccessAction
  | CreateUnsubscribeGroupFailureAction
  | UpdateUnsubscribeGroupRequestAction
  | UpdateUnsubscribeGroupSuccessAction
  | UpdateUnsubscribeGroupFailureAction
  | DeleteUnsubscribeGroupRequestAction
  | DeleteUnsubscribeGroupSuccessAction
  | DeleteUnsubscribeGroupFailureAction
  | ClearUnsubscribeGroupStateAction;
